import React from 'react';

export default function FeedbackCompletePane(props) {

    return (
        <React.Fragment>

            <div
                style={{
                    margin: "50px",
                    paddingTop: "50px",
                    paddingBottom: "30px",
                    border: "solid 2px white",
                    borderRadius: "15px",
                }}
            >
                <div
                    className={"default-font-huge default-font-bold"}
                >
                    Thank you for your feedback!
                </div>
                <div
                    style={{
                        margin: "30px"
                    }}
                >
                    Please check this website for news about next year's conference!
                </div>
            </div>

        </React.Fragment>
    )
}